module.exports = __webpack_public_path__ + "static/media/background.64c16307.png";